module.exports = __webpack_public_path__ + "img/oasis-6.8e7da079.png";